// extracted by mini-css-extract-plugin
export var searchHeader = "_2y-0";
export var searchHeaderDark = "_2y-1";